import storage from "../../storage"
import { navigation } from "../navigation"

/**
 * @param {String | Array<String>} roles
 */
export function RoleGuard(roles) {
    return function (to, from, next) {
        const userRoleName = storage.local.getUserRoleName()

        if (typeof roles == 'string') {
            if (userRoleName == roles)
                return next()
            else
                return next(navigation.main.forbidden.index)
        }
        else if (Array.isArray(roles)) {
            if (roles.includes(userRoleName))
                return next()
            else
                return next(navigation.main.forbidden.index)
        }
        else {
            throw new Error(`Role guard has not been implemented for parameter ${roles}`)
        }
    }
}
